module.exports = __webpack_public_path__ + "media/images/mypage/mypage_bg-545ba838b47e1d61da696b33d1a0fc98.gif";